// 1 / 11
// [{ id: 1, name: 1 }, { id: 2, name: 2 }, { id: 3, name: 3 }, { id: 11, name: 11, pid: 1 }]
// 1: { },
// 2: { },
// 3: { }
// 11: { }
export function getKeys(treeList, name) {
    let res = [];

    treeList.forEach((ele) => {
        if (ele.org_name.includes(name)) {
            res.push(ele.parent_id);
        }
    });
    return res;
}

export function filterTree(tree, key) {
    const filterChildrenTree = (resTree, treeItem) => {
        if (treeItem.org_name.includes(key)) {
            resTree.push(treeItem);

            return resTree;
        }
        if (Array.isArray(treeItem.children)) {
            const children = treeItem.children.reduce(filterChildrenTree, []),

             data = { ...treeItem, children };

            if (children.length) {
                resTree.push({ ...data });
            }
        }

        return resTree;
    };
    return tree.reduce(filterChildrenTree, []);
}

export const listToTree = (data) => {
    const obj = {};
    data.forEach((item) => {
        obj[item.id] = item;
        item.isLeaf = Boolean(item.is_leaf);
        item.title = null; //antd 会默认根据此属性向dom增加title属性
    });

    const res = [];
    data.forEach((item) => {
        const parent = obj[item.parent_id];
        if (parent) {
            // * 当前项有父节点
            item.path = parent.path ? parent.path + '/' + item.org_name : parent.org_name + '/' + item.org_name;
            // item.path = parent.path || '' + parent.org_name + '/' + item.org_name;
            obj[item.id].path = item.path;
            // is_optional  0:不可选 1：可选
            item.disabled = item.is_optional === 0;
            item.pathId = parent.pathId ? parent.pathId + '/' + item.id : parent.id + '/' + item.id;
            obj[item.id].pathId = item.pathId;
            parent.children = parent.children || [];
            parent.children.push(item);
        } else {
            // * 当前项没有父节点 -> 顶层
            obj[item.id].path = item.org_name;
            item.path = item.org_name;
            obj[item.id].pathId = item.id;
            item.pathId = item.id;
            // is_optional  0:不可选 1：可选  当is_optional 不存在或者 等于1 时可选
            item.disabled = item.is_optional === 0;
            res.push(item);
        }
    });
    return res;
};

//将子级数据插入到对应id的children中---同步树未用到
// const updateTreeData = (list, id, children) => {
//     return list.map((node) => {
//         node.isLeaf = node.is_leaf === 1;
//         node.title = null; //antd 会默认根据此属性向dom增加title属性
//         if (node.id === id) {
//             return {
//                 ...node,
//                 children
//             };
//         }
//         if (node.children) {
//             return {
//                 ...node,
//                 children: updateTreeData(node.children, id, children)
//             };
//         }
//         return node;
//     });
// };
